<template>
    <div>
      <v-btn 
        class="error" 
        rounded 
        small 
        @click="open()">
        <v-icon>mdi-power</v-icon>
        Reactivate
      </v-btn>
      <v-navigation-drawer
        app
        temporary
        right
        disable-resize-watcher
        width="650px"
        v-model="show"
        class="actionDrawer"
      >
        <v-row class="mx-4 mt-4" justify="center" align="center">
          <v-col cols="2">
            <v-btn @click="clearOperation()" color="primary" icon>
              <v-icon>mdi-arrow-left-bold-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="8" class="text-center">
            <v-img
              :src="this.$store.state.agency.agencyLogo"
              width="280px"
              class="mx-auto"
            />
          </v-col>
          <v-col cols="2"> </v-col>
        </v-row>
        <v-row class="mx-4 my-4 text-center">
          <v-col v-if="alert" cols="12">
            <generalAlert
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
          </v-col>
          <v-col cols="12">
            <h3>Reactivate Subscription</h3>
            <p class="mb-0">
              This is the section where you can reactivate your subscription, and all
              we need from you is to provide a reason for the reactivate.
            </p>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-card flat>
              <v-form ref="form" v-model="valid">
                <v-card-text>
                  <v-textarea
                    :rules="requiredRules"
                    v-model="reason"
                    label="Reason"
                    auto-grow
                    outlined
                    rows="1"
                    row-height="15"
                  ></v-textarea>
                  <v-btn
                    small
                    :disabled="!valid"
                    rounded
                    class="primary"
                    @click="reactivatePaypalSubcription()"
                  >
                    Submit
                  </v-btn>
                </v-card-text>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="120"
            ><p class="mb-0 overlaytext">Please Wait...</p></v-progress-circular
          >
        </v-overlay>
      </v-navigation-drawer>
    </div>
  </template>
  
  <script>
  import { getFunctions, httpsCallable } from "firebase/functions";
  import { firebaseApp } from "../../firebaseConfig";
  import generalAlert from "../alerts/generalAlert.vue";
  
  export default {
    props: ["subscription", "successAlert"],
    components: {
      generalAlert,
    },
    data: () => ({
      show: false,
      valid: false,
      overlay: false,
      reason: "",
      requiredRules: [(v) => !!v || "This Field Is Required"],
      alert: false,
      alertType: "",
      successResponse: "",
    }),
    methods: {
      //open New Subscribtion Drawer and display over Layer
      open() {
        this.show = !this.show;
      },
      clearOperation() {
        this.reason = "";
        this.show = false;
      },
      validate() {
        this.$refs.form.validate();
      },
      reactivatePaypalSubcription(){
        this.overlay = true;
        try{
          const functions = getFunctions(firebaseApp, "europe-west2");
          const paypalReactivateSubscriptionImmediately = httpsCallable(functions, "paypalReactivateSubscriptionImmediately");
  
          paypalReactivateSubscriptionImmediately({
            paypalSubscriptionId:this.subscription.paypalSubscriptionId,
            subscriptionUid: this.subscription.uid,
            activateReason: this.reason,
          }).then((result) => {
              console.log('result activatePayPalSub', result)
              console.log('result activateFirebaseSub', result)
              this.overlay = false;
              this.alertType = "success";
              this.successResponse = "Subscription Successfully Reactivated!";
              this.$emit("successAlert", this.successResponse, this.alertType);
              this.$refs.form.reset();
              this.show = false;
          });
        }catch(error){
              console.log(error)
              this.overlay = false;
              this.alert = true;
              this.alertType = "error";
              this.successResponse = `Subscription Reactivation Unsuccessful! Subscription may not exist or system is unavalible at the moment please try again later. Else contact support.`;
              setTimeout(() => {
                this.alert = false;
              }, 8000);
        }
      },
    },
  };
  </script>
  